import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { defineMessages, injectIntl, useIntl } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';
import api from '@/shared/api';
import config from '@/config';
import DataCacheService from '@/shared/services/DataCacheService';
import MultiSelect, { addItem, removeItem, splitItems } from './MultiSelect';

const messages = defineMessages({
  EmptyFiscalYear: 'Without fiscal year',
  EndFiscalYear: 'End fiscal year',
});

function useFiscalYears(intl) {
  const [fiscalYears, setfiscalYears] = useState([]);
  const dataCache = DataCacheService.getDataCache();
  useEffect(() => {
    let mounted = true;
    if (dataCache && dataCache.fiscalYears) {
      setfiscalYears(dataCache.fiscalYears);
    } else {
      api.base.get(`${config.appUrls.api}/api/relation/fiscalYears`).then(({ data }) => {
        if (!mounted || !data || !data.length) return;
        const years = data.map(fiscalYear => ({
          id: fiscalYear,
          label: moment.utc(fiscalYear).format('D/MM'),
        }));
        if (dataCache) dataCache.fiscalYears = years;
        setfiscalYears(years);
      });
    }
    return () => {
      mounted = false;
    };
  }, [dataCache, dataCache.fiscalYears]);

  return [
    {
      id: '0001-01-01',
      label: intl.formatMessage(messages.EmptyFiscalYear),
    },
    ...fiscalYears,
  ];
}

const EndFiscalYearMultiSelect = ({ selection, onChange, intl }) => {
  const items = useFiscalYears(intl);

  const [selectedItems, selectableItems] = splitItems(items, selection);

  return (
    <MultiSelect
      selectedItem={selectedItems}
      onItemRemoved={item => onChange(removeItem(selection, item))}
      onItemSelected={item => onChange(addItem(selection, item))}
      items={selectableItems}
      placeholder={intl.formatMessage(messages.EndFiscalYear)}
    />
  );
};
EndFiscalYearMultiSelect.propTypes = {
  selection: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  onChange: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
};
EndFiscalYearMultiSelect.defaultProps = {
  selection: [],
};

export default injectIntl(EndFiscalYearMultiSelect);
